import type { AllHTMLAttributes, ReactNode } from 'react';
import { focusInvalidAfterSubmit } from './Field';

type PanelProps = {
  as?: 'div' | 'section' | 'article' | 'aside' | 'form' | 'li';
  hover?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  children: ReactNode;
} & Omit<AllHTMLAttributes<HTMLElement>, 'children'>;

const PAD = { none: '', sm: 'p-3', md: 'p-4 sm:p-5', lg: 'p-5 sm:p-7' } as const;

/** The one surface: a glass panel with a hairline. Everything that is not the ground sits on one. */
export function Panel({
  as = 'div',
  hover = false,
  padding = 'md',
  children,
  className = '',
  onSubmit,
  ...rest
}: PanelProps) {
  const Tag = as;
  return (
    <Tag
      className={`panel ${hover ? 'panel-hover' : ''} ${PAD[padding]} ${className}`}
      {...rest}
      onSubmit={
        as === 'form'
          ? (event) => {
              onSubmit?.(event);
              focusInvalidAfterSubmit(event.currentTarget);
            }
          : onSubmit
      }
    >
      {children}
    </Tag>
  );
}
